
import { ServiceFAQSection } from "@/components/services/ServiceFAQSection";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothFAQ = () => {
  return (
    <ServiceFAQSection
      title="Frequently Asked Questions"
      subtitle="Common Questions About Wisdom Tooth Removal"
      faqs={wisdomToothData.faqs}
    />
  );
};
